import { useState } from "react";

import { Header } from "@/components/header";
import { mockCases, mockCompanies, mockDomains } from "@/lib/mock-data";
import type {
  CaseNotice,
  Company,
  DomainNotice,
  SearchType,
} from "@/lib/types";
import { CompanyDetail } from "@/pages/company-detail";
import { NoticeDetail } from "@/pages/notice-detail";
import { SearchInterface } from "@/pages/search-interface";

function App() {
  const [searchType, setSearchType] = useState<SearchType>("case");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedNotice, setSelectedNotice] = useState<
    CaseNotice | DomainNotice | Company | null
  >(null);

  const handleSearch = () => {
    if (!searchQuery.trim()) return;

    if (searchType === "case") {
      const foundCase = mockCases.find(
        (c) => c.caseNumber.toLowerCase() === searchQuery.toLowerCase()
      );
      setSelectedNotice(foundCase ?? null);
    } else if (searchType === "domain") {
      const foundDomain = mockDomains.find(
        (d) => d.domain.toLowerCase() === searchQuery.toLowerCase()
      );
      setSelectedNotice(foundDomain ?? null);
    } else {
      const foundCompany = mockCompanies.find(
        (c) => c.name.toLowerCase() === searchQuery.toLowerCase()
      );
      setSelectedNotice(foundCompany ?? null);
    }
  };

  const handleReset = () => {
    setSearchQuery("");
    setSelectedNotice(null);
  };

  const isCompany = (
    notice: CaseNotice | DomainNotice | Company | null
  ): notice is Company => {
    return notice !== null && "blockedDomains" in notice;
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <div className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
          <h1 className="text-xl sm:text-2xl font-medium">
            NCVIC Removals Registry
          </h1>
          <p className="text-gray-600 mt-2 text-sm sm:text-base">
            Search for public case numbers or domains to view takedown notices
            and appeal decisions
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        {!selectedNotice ? (
          <SearchInterface
            searchType={searchType}
            setSearchType={setSearchType}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSearch={handleSearch}
          />
        ) : isCompany(selectedNotice) ? (
          <CompanyDetail company={selectedNotice} onBack={handleReset} />
        ) : (
          <NoticeDetail
            notice={selectedNotice}
            searchType={searchType}
            onBack={handleReset}
          />
        )}
      </main>
    </div>
  );
}

export default App;
